import { useQuery } from '@tanstack/react-query';
import { api, GrLeaderboardGameInfo } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseLeaderboardGamesReturn {
  games: GrLeaderboardGameInfo[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useLeaderboardGames(): UseLeaderboardGamesReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.leaderboardGames(),
    queryFn: () => api.getGameRewardsLeaderboardGames(),
  });

  return {
    games: data?.games ?? [],
    loading: isLoading,
    error:
      error instanceof Error ? error.message : isError ? 'Failed to load leaderboard games' : null,
    refresh: () => {
      refetch();
    },
  };
}
